module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_5_4.65de1604.png";